const SLICE_NAME = 'aiSlice';

enum SuggestionStatus {
  new = 'new',
  accept = 'accept',
  reject = 'reject',
}

export { SLICE_NAME, SuggestionStatus };
